import "#legacy/shared/client/jst.js";
import "#/legacy/namespaces.js";
import "#finder-legacy/physician_finder/views/base.js";
import "#legacy/application/responsive/index.js";

const PATIENT_TYPES = {
  any: "",
  new: "new",
  returning: "returning",
};

const SHOW_MORE_SLOTS_FILTER_ATTRIBUTES = ["available_times", "visit_types", "accepting_patients"];

DoctorFinder.Views.SearchResults = class SearchResults extends DoctorFinder.Views.Base {
  static {
    this.prototype.template = false;
  }

  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
    this.updateStickyMapOffset = this.updateStickyMapOffset.bind(this);
    this.showListView = this.showListView.bind(this);
    this.showMapView = this.showMapView.bind(this);
    this.navigateToDate = this.navigateToDate.bind(this);
    this.prepareFilters = this.prepareFilters.bind(this);
    this.getMap = this.getMap.bind(this);
  }

  initialize() {
    super.initialize(...arguments);

    const props = {
      collection: this.collection,
      stickyHeaderOffset: this.options.stickyHeaderOffset,
      doctorMessages: this.options.doctorMessages,
      resultConfig: this.options.resultConfig,
      i18n: this.I18n,
    };

    this.mapElement = document.createElement("sp-finder-map");
    this.mapElement.id = "doctor-finder-search-results-map-scroll-container";
    if (this.options.listLayout === "slideshow") {
      this.listResultsView = new DoctorFinder.Views.SlideshowResults(
        Object.assign({}, props, {
          el: this.options.resultsViewElement,
          maxResults: this.options.maxResults,
        }),
      );
    } else {
      this.listResultsView = new DoctorFinder.Views.ListResults(
        Object.assign({}, props, {
          el: this.options.resultsViewElement,
          maxResults: this.options.maxResults,
          pagination: this.options.pagination,
          hideMapView: this.options.hideMapView,
        }),
      );
    }

    // BEHAVIOURS

    return this;
  }

  // EVENT HANDLERS

  handleShowMoreSlots(event, { focusDate, filters }) {
    filters = this.prepareFilters(filters);
    return AppointmentBooking.showSlotPickerModal({
      focusDate,
      filters,
      options: {
        onSlotPick: (slot, slotElement) => this.triggerEvent(DoctorFinder.Events.wizard.slotPick, slot, slotElement),
      },
    });
  }

  handleResultsSlotClick(event, slotElement) {
    const slot = {}; // TODO: Extract slot data
    return this.triggerEvent(DoctorFinder.Events.wizard.slotPick, slot, slotElement);
  }

  // RENDERING

  render() {
    if (this.mapElement.parentNode !== this.el) {
      this.el.append(this.mapElement, this.listResultsView.el);
    }

    if (this.isMobileSize()) {
      this.showListView();
    } else if (this.collection.selectedView === "map") {
      // NOTE: If view selection param or values are refactored, don't forget to update SearchSession::MAP_VIEW_PARAM_VALUE
      this.showMapView();
    } else if (this.collection.selectedView === "bio") {
      this.showListView();
    }

    return this;
  }

  showListView() {
    // Mobile selected-provider dialogs belong to the map app even in list view.
    this.mapElement.style.display = this.isMobileSize() ? "" : "none";
    this.listResultsView.$el.show();
    return this.listResultsView.render();
  }

  showMapView() {
    if (this.listResultsView.el.style.display !== "none") {
      this.holdHeightUntilNextFrame();
    }
    this.listResultsView.$el.hide();
    this.mapElement.style.display = "";
    return this;
  }

  // The map app renders after this view switches, so the held height keeps the page scroll in place meanwhile.
  holdHeightUntilNextFrame() {
    const el = this.el;
    function releaseHeight() {
      el.style.minHeight = "";
    }
    el.style.minHeight = `${el.offsetHeight}px`;
    requestAnimationFrame(releaseHeight);
  }

  updateStickyMapOffset() {
    // The map app observes its own header and sidebar geometry.
  }

  // HELPER METHODS

  navigateToDate(date) {
    if (!date) {
      return;
    }
    if (this.$el.find("#doctor-map-container").length) {
      return;
    }
    return this.collection.updateFilters({ slots_ui_start_date: date });
  }

  prepareFilters(filters) {
    const collectionFilters = _.pick(this.collection.filters, ...Array.from(SHOW_MORE_SLOTS_FILTER_ATTRIBUTES));
    filters = _.extend({}, filters, collectionFilters);
    filters.patient_type = this.collection.filters.new_patient === "true" ? PATIENT_TYPES.new : PATIENT_TYPES.any;
    return filters;
  }

  getMap() {
    return this.mapElement.querySelector("sp-google-map")?.map;
  }
};
